import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './css/App.css';
import './css/TMobileApp.css';
import ApplinksApp from './components/App/ApplinksApp';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ApplinksApp />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
